import { DoqFaceSvgProps } from '../types';

const TableError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 320 320"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g clipPath="url(#clip0_2666_52825)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-table-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#EBD4FF"
        mask="url(#bottom-mask-table-error)"
      />
      <mask
        id="mask0_3451_99123"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_3451_99123)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#C07E02"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#C07E02"
      />
      <g opacity="0.5">
        <path
          d="M96 243C96 242.448 96.4477 242 97 242H223C223.552 242 224 242.448 224 243V245C224 245.552 223.552 246 223 246H97C96.4477 246 96 245.552 96 245V243Z"
          fill="#C07E02"
        />
        <path
          d="M96 277C96 276.448 96.4477 276 97 276H223C223.552 276 224 276.448 224 277V279C224 279.552 223.552 280 223 280H97C96.4477 280 96 279.552 96 279V277Z"
          fill="#C07E02"
        />
        <path
          d="M97 258C96.4477 258 96 258.448 96 259V261C96 261.552 96.4477 262 97 262H223C223.552 262 224 261.552 224 261V259C224 258.448 223.552 258 223 258H97Z"
          fill="#C07E02"
        />
        <path
          d="M96 293C96 292.448 96.4477 292 97 292H223C223.552 292 224 292.448 224 293V295C224 295.552 223.552 296 223 296H97C96.4477 296 96 295.552 96 295V293Z"
          fill="#C07E02"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159 200C153.078 200 147.907 203.217 145.141 208L150.056 208C152.253 205.545 155.446 204 159 204C162.554 204 165.747 205.545 167.944 208L172.859 208C170.093 203.217 164.922 200 159 200Z"
        fill="#C07E02"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.5 132L120 143H105L112.5 132ZM96 106C87.1634 106 80 113.163 80 122V143H240V122C240 113.163 232.837 106 224 106H96Z"
        fill="#546477"
      />
    </g>
    <defs>
      <clipPath id="clip0_2666_52825">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { TableError };
